import React, { CSSProperties } from "react";

export type DeltaPolarity = "up-good" | "down-good";

type Props = {
    value: number | null | undefined;
    unit?: "%" | "pp";
    polarity?: DeltaPolarity;
};

const formatValue = (value: number, unit: "%" | "pp"): string => {
    const sign = value > 0 ? "+" : "";
    return `${sign}${value.toFixed(1)}${unit === "pp" ? "pp" : "%"}`;
};

export const Delta: React.FC<Props> = ({ value, unit = "%", polarity = "up-good" }) => {
    if (value === null || value === undefined) return null;
    const positive = polarity === "down-good" ? value < 0 : value > 0;
    const negative = polarity === "down-good" ? value > 0 : value < 0;
    const cls = positive ? "delta delta--up" : negative ? "delta delta--down" : "delta delta--flat";
    const arrow = value > 0 ? "▲" : value < 0 ? "▼" : "•";
    return (
        <span className={cls}>
            <span style={arrowStyle}>{arrow}</span>
            {formatValue(value, unit)}
        </span>
    );
};

const arrowStyle: CSSProperties = { fontSize: 9, lineHeight: 1 };
